import { Card } from "./styles";
import * as IconMui from "@mui/icons-material";
import permissionsStore from "../../../../store/permissions";
import { Permissions } from "@/modules/users/models";
import { useNavigate } from "react-router-dom";

interface IHomeCardProps {
  title: string;
  description: string;
  icon: keyof typeof IconMui;
  permission: Permissions;
  url: string;
}

export const HomeCard: React.FC<IHomeCardProps> = ({
  title,
  description,
  icon,
  permission,
  url,
}) => {
  const { permissions: userPermissions } = permissionsStore();
  const navigate = useNavigate();

  const IconComponent = IconMui[icon];
  if (!IconComponent) {
    console.error(`Icon ${icon} does not exist in IconMui`);
    return null;
  }

  const hasPermission = (permission: Permissions) => {
    return userPermissions.includes(permission);
  };
  return (
    <>
      {hasPermission(permission) ? (
        <Card onClick={() => navigate(url)}>
          <IconComponent sx={{ color: "white", fontSize: 40, marginTop:"16px" }} />
          <div className="data">
            <h2 className="title">{title}</h2>
            <p className="description">{description}</p>
          </div>
        </Card>
      ) : (
        <></>
      )}
    </>
  );
};
